import React from "react";
import CustomErrorPage from "./CustomErrorPage";

interface ErrorBoundaryState {
  hasError: boolean;
  error: Error | null;
}

class ErrorBoundary extends React.Component<
  React.PropsWithChildren,
  ErrorBoundaryState
> {
  constructor(props: React.PropsWithChildren) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error("Error caught in ErrorBoundary:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        // <div style={{ textAlign: "center", padding: "2rem" }}>
        //   <h1>Something went wrong!</h1>
        //   <p>{this.state.error?.message || "Please try again later."}</p>
        // </div>
        <CustomErrorPage />
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
